export default __webpack_public_path__ + "static/media/logo-sm.bb15aee6.png";